import { Button, theme } from "antd";
import { PropsWithChildren } from "react";
import { CssVars } from "src/components/CssVars";

export function CardEditor({
  children,
  title,
  onCancel,
  onOk,
  okText,
  cancelText,
}: PropsWithChildren<{
  title: string;
  onOk(): void;
  onCancel(): void;
  okText?: string;
  cancelText?: string;
}>) {
  return (
    <Mask>
      <Container>
        <Title>{title}</Title>
        <Content>{children}</Content>
        <Footer>
          <Button type="text" onClick={() => onCancel()}>
            {cancelText || "Cancel"}
          </Button>
          <Button type="primary" onClick={() => onOk()}>
            {okText || "Apply"}
          </Button>
        </Footer>
      </Container>
    </Mask>
  );
}

function Mask({ children }: PropsWithChildren) {
  const { token } = theme.useToken();
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        height: "100vh",
        width: "100vw",
        zIndex: 1000,
        backgroundColor: token.colorBgMask,
        padding: 24,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {children}
    </div>
  );
}

function Container({ children }: PropsWithChildren) {
  const { token } = theme.useToken();
  return (
    <div
      style={{
        maxHeight: "95vh",
        width: "95vw",
        maxWidth: 1600,
        minWidth: 800,
        display: "flex",
        flexDirection: "column",
        backgroundColor: token.colorBgContainer,
        borderRadius: 16,
        boxShadow: token.boxShadowSecondary,
      }}
    >
      {children}
    </div>
  );
}

function Title({ children }: PropsWithChildren) {
  return (
    <div style={{ padding: 16, fontSize: 16, fontWeight: 600 }}>{children}</div>
  );
}

function Content({ children }: PropsWithChildren) {
  return (
    <div
      style={{
        paddingLeft: 16,
        paddingRight: 16,
        flex: 1,
        minHeight: 0,
        maxHeight: "calc(95vh - 120px)",
        overflow: "auto",
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
    >
      <CssVars>{children}</CssVars>
    </div>
  );
}

function Footer({ children }: PropsWithChildren) {
  return (
    <div
      style={{
        gap: 8,
        display: "flex",
        justifyContent: "flex-end",
        padding: 16,
      }}
    >
      {children}
    </div>
  );
}
